import React, {useEffect, useState} from "react";
import {Square2StackIcon} from "@heroicons/react/24/outline";
import CheckIcon from "@heroicons/react/24/outline/CheckIcon";
import Tooltip from "../../tooltip";
import {classNames} from "../../../util/util-helpers";


export default function CopyToClipboardButtonCustomizable({
                                                              className,
                                                              classNameCopied = className,
                                                              iconClass,
                                                              iconClassCopied,
                                                              clipboardText,
                                                              tooltip,
                                                              tooltipCopied,
                                                              Icon = Square2StackIcon,
                                                              IconCopied = CheckIcon,
                                                              baseClass
                                                          }) {
    const [isCopied, setIsCopied] = useState(false);

    const copyToClipboard = () => {
        if (!isCopied) {
            navigator.clipboard.writeText(clipboardText).then(() => setIsCopied(true))
        }
    }

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => setIsCopied(false), 1500);
        }
    }, [isCopied]);

    return isCopied
        ? <Tooltip key={1} delay={[0]} showOnCreate={true} hideOnClick={false} trigger="focus" content={tooltipCopied}>
            <button
                onClick={copyToClipboard}
                className={classNames(classNameCopied, baseClass)}
            >
                <IconCopied className={iconClassCopied}/>
            </button>
        </Tooltip>
        : <Tooltip key={2} delay={[0]} hideOnClick={false} content={tooltip}>
            <button
                onClick={copyToClipboard}
                className={classNames(className, baseClass)}
            >
                <Icon className={iconClass}/>
            </button>
        </Tooltip>
}